import React from "react"
import {findDOMNode} from "react-dom"

import PopoverAddColumn from "../../../../../../gd-modules/common/add-column-new/popover/popover"
import Popover from "../../../../../../gd-components/gd-popover/popover"
import FieldSelectField from "../../select-group-field"
import convertFieldsStructureToConfig from "../../../../../../gd-modules/common/add-column-new/convert-fields-structure"
import GroupBy from "../../../../../../gd/manager/group-by/group-by-model"
import {PopoverAttachmentType} from "../../../../../../gd-components/gd-popover/@const";

export default function FieldSelectGroupField_Popover(props:any) {

    const field : FieldSelectField = props.field

    const manageColumnsConfig = convertFieldsStructureToConfig(field.fieldsStructure, props.model?.restrictedFields)
    const groupBy = props.field.getViewValue(props.model) as GroupBy

    const onSelect = (fieldId:ID, params: any) => {
        props.parent.hidePopover()
        props.parent.onValueChange(new GroupBy({
            fieldId,
            sortDirection: groupBy.sortDirection,
            params,
        }))
    }

    return (
        <Popover popoverClass       = "gd-popover-add-column-new h-300"
                 attachment         = {props.options?.attachment}
                 targetAttachment   = {props.options?.targetAttachment}
                 offset             = {props.offset}
                 attachmentType     = {PopoverAttachmentType.HORIZONTAL}
                 arrowsVersion      = {2}
                 onClickOutside     = {()=>{props.parent.hidePopover()}}
                 getTargetFunc      = {()=>findDOMNode(props.parent)}>
            <PopoverAddColumn manageColumnsConfig   = {manageColumnsConfig}
                              fields                = {field.fields.models}
                              columns               = {[{
                                  fieldId : groupBy.field?.fieldId,
                                  params  : groupBy.params
                              }]}
                              mandatoryColumnsIds   = {[]}
                              noValueOption         = {field.noValueOption ? {icon: field.noValueOptionIcon, label: field.noValueOptionLabel} : undefined}
                              showAdd               = {false}
                              showModifierOptions   = {true}
                              hidePopover           = {props.parent.hidePopover}
                              onToggleColumn        = {onSelect}
                              onNewCustomField      = {()=>{}}/>
        </Popover>
    )
}